import {ActionContext, ActionTree} from 'vuex';
import {RootState} from '@/store/type';
import {HttpService} from '@/services/api';
import {
  AddressInitState,
  Amphures,
  Provinces,
  ResponseAmphures, ResponseDistricts,
  ResponseProvinces
} from '@/store/address/address.types';
import {AddressEnumApi} from '@/store/address/address.enum';

export const AddressAction: ActionTree<AddressInitState, RootState> = {
  async _getProvinces(req: ActionContext<AddressInitState, RootState>, params?: Provinces): Promise<void> {
    let {commit} = req;
    try {
      let provinces = await HttpService.get(`${AddressEnumApi.address}provinces`, params) as { data: ResponseProvinces };
      if (provinces.data.appCode === 20000) {
        commit('mutationGetProvinces', provinces.data.data);
      } else {
        commit('mutationGetProvinces', []);
      }
    } catch (e) {
      commit('mutationGetProvinces', []);
      console.error('DEBUG: _getProvinces ', e.message);
    }
  },
  async _getAmphures(req: ActionContext<AddressInitState, RootState>, params: string): Promise<void> {
    let {commit} = req;
    try {
      let amphures = await HttpService.get(`${AddressEnumApi.address}amphures/${params}`, params) as { data: ResponseAmphures };
      if (amphures.data.appCode === 20000) {
        commit('mutationGetAmphures', amphures.data.data);
      } else {
        commit('mutationGetAmphures', []);
      }
    } catch (e) {
      commit('mutationGetAmphures', []);
      console.error('DEBUG: _getProvinces ', e.message);
    }
  },
  async _getDistricts(req: ActionContext<AddressInitState, RootState>, params: string): Promise<void> {
    let {commit} = req;
    try {
      let districts = await HttpService.get(`${AddressEnumApi.address}districts/${params}`) as { data: ResponseDistricts };
      if (districts.data.appCode === 20000) {
        commit('mutationGetDistricts', districts.data.data);
      } else {
        commit('mutationGetDistricts', []);
      }
    } catch (e) {
      commit('mutationGetDistricts', []);
      console.error('DEBUG: _getProvinces ', e.message);
    }
  },
  async _getProvincesById(req: ActionContext<AddressInitState, RootState>, params: string): Promise<string> {
    try {
      let province = await HttpService.get(`${AddressEnumApi.address}provinces/id/${params}`, params) as { data: ResponseProvinces };
      if (province.data.appCode === 20000) {
        if( province.data.data.length !== 0) {
          return province.data.data[0].nameTH
        }else {
          return '';
        }
      } else {
        return '';
      }
    } catch (e) {
      return '';
    }
  },
  async _getDistrictsById(req: ActionContext<AddressInitState, RootState>, params: string): Promise<string> {
    try {
      let district = await HttpService.get(`${AddressEnumApi.address}districts/id/${params}`, params) as { data: ResponseDistricts };
      if (district.data.appCode === 20000) {
        if( district.data.data.length !== 0) {
          return district.data.data[0].nameTH
        }else {
          return '';
        }
      } else {
        return '';
      }
    } catch (e) {
      return '';
    }
  },
  async _getAmphuresById(req: ActionContext<AddressInitState, RootState>, params: string): Promise<string> {
    try {
      let amphure = await HttpService.get(`${AddressEnumApi.address}amphures/id/${params}`, params) as { data: ResponseDistricts };
      if (amphure.data.appCode === 20000) {
        if( amphure.data.data.length !== 0) {
          return amphure.data.data[0].nameTH
        }else {
          return '';
        }
      } else {
        return '';
      }
    } catch (e) {
      return '';
    }
  },

};
